
import BaseButton from "@/components/base/BaseButton.vue";
import useBookingNavigation from "@/composables/useBookingNavigation";
import { useUserStore } from "@/store/user";
import { defineComponent, ref } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useBookingStore } from "@/store/booking";
import useBooking from "@/composables/useBooking";
import { dialogKey, DialogMessage, DialogType } from "@/models/symbols/Dialog";
import { useEventBus } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import useRuntimeConfig from "@/composables/useRuntimeConfig";
import { UserType } from "@/models/enums";

export default defineComponent({
	props: {
		isLastStep: {
			type: Boolean,
			default: false,
		},
		loadingStep: {
			type: Boolean,
			required: false,
		},
	},
	components: {
		BaseButton,
	},
	setup() {
		const { nextStep, prevStep, currentStepIsValid, loadingNextStep } =
			useBookingNavigation();
		const { cancelActiveBooking } = useBooking();
		const { getRuntimeConfig } = useRuntimeConfig();
		const bookingStore = useBookingStore();
		const userStore = useUserStore();
		const isLoggedIn = computed(() => userStore.getIsLoggedIn);
		const v$ = useVuelidate();
		const route = useRoute();
		const bus = useEventBus<DialogMessage>(dialogKey);
		const { t } = useI18n();
		const loading = ref<boolean>(false);

		const isAmendmentMode = computed(
			() => bookingStore.getBooking.amendmentMode
		);

		const isFirstStep = computed(() => {
			return route.query.step ?? "1" === "1";
		});

		const displayCancelBtn = computed(() => {
			return (
				bookingStore.getBooking.amendmentMode ||
				![undefined, "1"].includes(route.query.step as string)
			);
		});

		const displayContinueBtn = computed(() => {
			if (!isLoggedIn.value && route.query.step === "4") {
				return false;
			}

			return true;
		});

		const displayNav = computed(() => {
			if (
				userStore.getUserType === UserType.Agent &&
				route.query.step === "5"
			) {
				return false;
			}

			switch (route.query.step) {
				case "6":
					return false;
				default:
					return true;
			}
		});

		const cancel = () => {
			bus.emit({
				title: t("messages.cancel.title"),
				message: t("messages.cancel.body"),
				yes: t("button.yes"),
				no: t("button.no"),
				callback: () => {
					loading.value = true;

					getRuntimeConfig().then((x) =>
						cancelActiveBooking(
							isAmendmentMode.value ? x.accountUrl : `${x.bookUrl}?step=1`
						)
					);
				},
				type: DialogType.Warning,
			} as DialogMessage);
		};

		const forward = async () => {
			v$.value.$touch();
			const isValid = await v$.value.$validate();
			if (!isValid) {
				const firstError = (document as any).querySelector(".input-field__error") || 
					(document as any).querySelector("[validationerror]");
				
				if (firstError) {
					firstError.scrollIntoView({ block: "center", behavior: "smooth" });
				}
				return;
			}

			nextStep();
		};

		return {
			nextStep,
			prevStep,
			cancel,
			currentStepIsValid,
			forward,
			loadingNextStep,
			displayNav,
			displayContinueBtn,
			displayCancelBtn,
			loading,
			v$,
			isFirstStep
		};
	},
});
